import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/v2/Message";

export const InfoBoxUI = () => (
  <Message
    type="information"
    title="We're unlikely to receive more stock of this item"
  />
);
